import { localStorageService } from '../services/localStorage';
import {
  DSP_ADFORM,
  DSP_AMAZON,
  DSP_CRITEO,
  DSP_FREEWHEEL,
  DSP_VISTAR,
  DSP_XANDR,
} from './constants';

export function getInitialDsp(): string {
  try {
    const dspFromStorage = localStorageService.getItem<string>('currentDsp') || DSP_XANDR;

    if (
      dspFromStorage === DSP_VISTAR ||
      dspFromStorage === DSP_XANDR ||
      dspFromStorage === DSP_CRITEO ||
      dspFromStorage === DSP_ADFORM ||
      dspFromStorage === DSP_AMAZON ||
      dspFromStorage === DSP_FREEWHEEL
    ) {
      return dspFromStorage;
    }
  } catch {
    return DSP_XANDR;
  }

  return DSP_XANDR;
}
